import useTranslation from "next-translate/useTranslation";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  actions as BudgetActions,
  selectors as BudgetSelectors,
} from "../../../../redux/slices/v2/CalculezBudget";
import Share from "./../../../ShareCredits/Share";
import DossierIcon from "./DossierIcon";
import HomeIcon from "./HomeIcon";
import style from "./PrixDeBien.module.css";
import formatUrl from "utils/FormatUrl";

function PrixDeBien(props) {
  const Budget = useSelector(BudgetSelectors.budgetSelector);
  const MensualiteChoisi = useSelector(
    BudgetSelectors.MensualiteChoisiSelector
  );
  const MensualiteMax = useSelector(BudgetSelectors.MensualiteMaxSelector);

  const MensualiteSimple = useSelector(BudgetSelectors.revenuSimpleSelector);
  const MensualiteAvance = useSelector(BudgetSelectors.revenuAvanceSelector);
  const dispatch = useDispatch();

  const { t, lang } = useTranslation("creditImmo");

  const [showShare, setShowShare] = useState(false);

  const [value, setValue] = useState<number>(MensualiteChoisi);

  // const linkToShare = `https://www.agenz.ma/credit-immobilier/simulateur-credit-immobilier/rapport-detaille?salaireMensuel=${MensualiteSimple.salaireMensuel}&detteMensuel=${MensualiteSimple.detteMensuel}&Acompte=${MensualiteSimple.Acompte}&taux=${MensualiteAvance.tauxInt}&programme=${MensualiteAvance.Programme}&capacity=${MensualiteAvance.Capacity}`

  const linkToShare = formatUrl(
    `https://agenz.ma/fr/credit-immobilier/simulateur-credit-immobilier`,
    lang
  );

  const Input = styled.input`
    position: relative;
    appearance: none;
    outline: none;
    background: white;
    border-radius: 12px;
    border: transparent;
    box-shadow: none;
    border: 12px;
    display: flex;
    justify-content: center;
    align-content: center;
    overflow: hidden;
    height: 20px;

    &:before {
      position: absolute;
      content: "";
      width: ${(value * 100) / MensualiteMax < 50
        ? (value * 100) / MensualiteMax + 2
        : (value * 100) / MensualiteMax}%;
      height: 20px;
      background: ${(value * 100) / MensualiteMax === 100
        ? "#00B4FF"
        : (value * 100) / MensualiteMax < 0.5
        ? "#E7E7E7"
        : "#32E696"};
      left: ${(value * 100) / MensualiteMax < 0.5 ? "10px" : "0px"};
      top: 7px;
      border-radius: 12px;
    }
  `;

  const ToolPit = styled.span`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.9);
    top: -45px;
    left: ${(value * 100) / MensualiteMax < 60
      ? ((value * 100) / MensualiteMax).toFixed()
      : (value * 100) / MensualiteMax - 2}%;
    transform: translateX(-50%);
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    padding: 5px 16px;
    border-radius: 2px;
    width: max-content;
  `;

  useEffect(() => {
    setValue(MensualiteChoisi);
  }, [MensualiteChoisi]);

  useEffect(() => {
    dispatch(BudgetActions.setMensualiteChoisi(parseInt(value.toString())));
  }, [value]);

  return (
    <div className={style.PrixDeBienContainer}>
      {showShare ? (
        <Share
          setShowShare={setShowShare}
          linkToShare={linkToShare}
          t={t}
          lang={lang}
          message={"Calculez votre budget sur agenz"}
        />
      ) : null}
      {!props.rapport ? (
        <div className={style.buttonsContainer}>
          <button
            onClick={() => {
              window.location.href = `/${lang}/credit-immobilier/simulateur-credit-immobilier/rapport-detaille?salaireMensuel=${MensualiteSimple.salaireMensuel}&detteMensuel=${MensualiteSimple.detteMensuel}&Acompte=${MensualiteSimple.Acompte}&taux=${MensualiteAvance.tauxInt}&programme=${MensualiteAvance.Programme}&capacity=${MensualiteAvance.Capacity}`;
            }}
          >
            {t("Rapport détaillé")}
          </button>
          <button
            onClick={() => {
              setShowShare(true);
            }}
          >
            <span>
              <svg
                width="24"
                height="18"
                viewBox="0 0 24 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.2088 3.95909C15.2081 3.95909 15.2076 3.95966 15.2076 3.96036C15.2069 4.34633 14.8967 4.67062 14.5009 4.68537C10.1931 4.8651 6.65237 6.34967 4.11861 8.83382C2.14577 10.7677 0.773028 13.3217 0.119291 16.3575C0.0785149 16.5468 0.307342 16.6724 0.452162 16.5438C2.0665 15.11 3.81457 14.1375 5.70599 13.5682C8.38612 12.7607 11.3237 12.7705 14.5514 13.4033C14.9224 13.4426 15.2101 13.7553 15.2101 14.1295V17.0284C15.2101 17.205 15.4222 17.2949 15.5491 17.1722L23.8513 9.14499C23.9326 9.06639 23.9326 8.93606 23.8513 8.85745L15.5491 0.827906C15.4222 0.705149 15.2101 0.795093 15.2101 0.971669V3.95782C15.2101 3.95852 15.2095 3.95909 15.2088 3.95909Z"
                  fill="white"
                />
              </svg>
            </span>
            {t("Partager")}
          </button>
        </div>
      ) : (
        ""
      )}
      <div
        className={`${style.ResultContainer} ${
          props.rapport ? style.widthResult : ""
        }`}
      >
        <div>
          <p className={style.title}>{t("Prix du bien")}</p>
        </div>
        <div>
          <p className={style.text}>
            {t("Vous pouvez vous permettre une maison jusqu'à")}
          </p>
          <p className={style.prix}>
            {!isNaN(Budget)
              ? parseInt(Budget)
                  .toString()
                  .replace(/(.)(?=(\d{3})+$)/g, "$1 ")
              : 0}{" "}
            {t("MAD")}
          </p>
          <p className={style.text}>
            {t(
              "Selon vos revenus, une maison à ce prix devrait s'intégrer confortablement dans votre budget"
            )}
          </p>
        </div>
        <div className={style.progressContainer}>
          <div className={style.progressBack}>
            <Input
              type="range"
              id="range"
              defaultValue={value}
              disabled={!props.rapport ? false : true}
              name="range"
              min={0}
              max={MensualiteMax}
              onChange={(e) => {
                setValue(isNaN(e.target.value) ? 0 : e.target.value);
              }}
            />
            <ToolPit
              className={style.tooltip}
              style={{ display: !props.rapport ? "flex" : "none" }}
            >
              {value.toString().replace(/(.)(?=(\d{3})+$)/g, "$1 ")}{" "}
              {t("MAD/Mois")} <span className={style.arrowDown}></span>
            </ToolPit>
          </div>

          <div className={style.iconsContainer}>
            <div>
              <DossierIcon />
            </div>
            <div>
              <HomeIcon />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrixDeBien;
